import axios from "axios";
import { APIResponse } from "../models/NetworkResponse";
import { IDENTITY_PATH_PREFIX } from "./AuthSession";
import { setupAuthInterceptor } from "./setupAuthInterceptor";

setupAuthInterceptor();

export const postIdentityAPI = async (
  path: string,
  data?: unknown,
): Promise<APIResponse> => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL || ""}${IDENTITY_PATH_PREFIX}${path}`,
      data,
      { timeout: 20000 },
    );
    return response.data as APIResponse;
  } catch (error) {
    throw error;
  }
};
